export default "__VITE_ASSET__2913c235__"